class AddToCartController {
    /*@ngInject*/
    constructor($log, $rootScope, $timeout, AddToCartService, ProductDetailService) {
        $log.debug('AddToCartController initialized');
        this.$log = $log;
        this.$timeout = $timeout;
        this.addToCartService = AddToCartService;
        this.productDetailService = ProductDetailService;

        this.addToCartResponse = null;
        this.addToCartResponseTimeout = true;
        this.addToCartBtnText = null;
        this.addToCartBtnTextConfirmation = null;
        this.requestPending = false;
        this.successPending = false;
        this.addToCartReturnedError = false;

        $rootScope.$on('addToCartFinished', () => {
            this.addToCartResponse = this.addToCartService.getAddToCartResponse();
            this.requestPending = false;
            this.successPending = true;
            this.$timeout(() => {
                if (this.successfullyAddedToCart()) {
                    this.addToCartResponseTimeout = true;
                }
                this.successPending = false;
            }, 2000);
            this.addToCartResponseTimeout = false;
        });

        if(!$rootScope.$$listenerCount['addToCartTrigger']) {
            $rootScope.$on('addToCartTrigger', () => {
                // s2sAddToCart no oneSize and no dummy
                this.addToCart('false', 'false');
            });
        }

        $rootScope.$on('variantDataSuccess', () => {
            this.addToCartResponse = null;
            this.addToCartReturnedError = false;
        });
    }

    init(addToCartBtnText, addToCartBtnTextConfirmation) {
        this.addToCartBtnText = addToCartBtnText;
        this.addToCartBtnTextConfirmation = addToCartBtnTextConfirmation;
    }

    addToCart(isOneSize, hasDummyVariant) {
        if (this.productDetailService.getVariantData() == null) {
            this.productDetailService.setWarningSelectSize(true);
            return;
        }
        this.productDetailService.setWarningSelectSize(false);
        this.requestPending = true;
        this.addToCartService.addToCart(this.productDetailService.getVariantData().code, 1, this.productDetailService.getVariantData().ean, this.productDetailService.getVariantData().size, this.productDetailService.getVariantData().price.value, isOneSize, hasDummyVariant);
    }

    showWarningAddToCart() {
        if (this.addToCartResponse != null && this.addToCartResponse.result.errorMessage != null) {
            this.addToCartReturnedError = true;
            return this.addToCartResponse.result.errorMessage;
        }
        return null;
    }

    successfullyAddedToCart() {
        return this.addToCartResponse != null && this.addToCartResponse.result.success && !this.addToCartResponseTimeout;
    }

    showAddToCartButtonText() {
        return this.addToCartResponseTimeout || !this.successfullyAddedToCart() ? this.addToCartBtnText : this.addToCartBtnTextConfirmation;
    }
}

export default AddToCartController;
